import type { ConditionOptionsData, ConditionOptionsType } from '../../types/condition';

const getOptionsRowNodeId = (params: ConditionOptionsData | ConditionOptionsType): string => {
  // 需要家2、需要家3、受渡場所はnull/undefinedの可能性がある　→　undefinedに揃える
  const rowNodeId: string = (
    'customer1' +
    params.customer1 +
    '-customer2' +
    (params.customer2 ?? undefined) +
    '-customer3' +
    (params.customer3 ?? undefined) +
    '-deliveryLocation' +
    (params.deliveryLocation ?? undefined) +
    '-standard' +
    params.standard +
    '-size' +
    params.sizeDisplay
  )
    .split('.')
    .join('')
    .split(',')
    .join('');
  // console.log(rowNodeId);
  return rowNodeId;
};

export default getOptionsRowNodeId;
